const handleFileSource = (file) => {
  return !file.photo && !file.url
    ? file?.originalFile
      ? URL.createObjectURL(file.originalFile)
      : null
    : file.photo || file.url;
};
export default handleFileSource;
